import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Button } from '~/components/Button/Button';
import { PropsWithChildren, ReactNode } from 'react';
import styles from './Table.module.css';

type Props = PropsWithChildren & {
  /** Number of active filters inside the panel; shown on the button when greater than zero. */
  count?: number;
  /** Stretch the button to fill its container, e.g. when placed in a grid cell. */
  block?: boolean;
  /** Content pinned to the bottom of the panel, right-aligned, e.g. a reset button. */
  footer?: ReactNode;
};

export function Filter({ children, count = 0, block = false, footer }: Props) {
  return (
    <Popover className="relative">
      <PopoverButton as={Button} type="button" variant="secondary" block={block}>
        {count > 0 ? `Filtrering (${count})` : 'Filtrering'}
      </PopoverButton>

      <PopoverPanel anchor="bottom end" className={styles.filterPanel}>
        {children}
        {footer && <div className={styles.footer}>{footer}</div>}
      </PopoverPanel>
    </Popover>
  );
}
